// shared/ui/listColumns.jsx  (columnas comunes de los listados: selección única y enlace verde a editar)
import React from 'react';
import { Link } from 'react-router-dom';
import { Colors } from '../../../../constants/Colors.js';

export const LINK_COLOR = '#789D16';

/** Primera columna: checkbox de selección única (una sola fila seleccionada a la vez, por uuid). */
export const selectionColumn = ({ selectedUuid, onSelect }) => ({
  Header: '',
  id: 'seleccion',
  accessor: 'uuid',
  width: 25,
  Cell: ({ row }) => (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        style={{ width: 20, height: 20, accentColor: Colors.primary_600 }}
        checked={selectedUuid === row.original.uuid}
        onChange={event => onSelect(event.target.checked ? row.original.uuid : null)}
      />
    </div>
  ),
});

/** Celda con enlace verde a `getPath(fila)`; si no hay ruta (falsy) muestra solo el texto. */
export const editLinkCell = getPath => {
  const EditLinkCell = ({ value, row }) => {
    const path = getPath(row.original);
    return path ? (
      <Link to={path} style={{ color: LINK_COLOR }}>
        <span>{value}</span>
      </Link>
    ) : (
      <span>{value}</span>
    );
  };
  return EditLinkCell;
};
